module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMS40ODIgNzAuMTMxbDM2LjIwNCAxNi4xOCA2OS45MzItNjUuNDg1LTYxLjM4IDcwLjU5NCA0Ni40MzUgMTguNzM1YzEuMTE5LjQyNSAyLjM5Ny0uMTcgMi43OTctMS4zNjN2LS4wODVMMTI3Ljk5OC4wNDcgMS4zMjIgNjUuODc0Yy0xLjEyLjU5Ny0xLjUxOSAxLjk1OS0xLjA0IDMuMTUxLjMyLjUxMS43Mi45MzcgMS4yIDEuMTA3em00NC42NzYgNTcuODIxTDY0LjIyIDEwNy4yNmwtMTguMDYyLTcuODM0djI4LjUyN3oiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/guide.svg
// module id = 1735
// module chunks = 1